import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { LoginComponent } from './components/login/login.component'
import { MainLayoutComponent } from './components/main-layout/main-layout.component'
import { AuthGuard } from './services/auth.guard'

const routes: Routes = [
  {
    path: 'login',
    // redirectTo: 'articles',
    pathMatch: 'full',

    component: LoginComponent,
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'new-questionnaires',
        loadChildren: () =>
          import('./modules/new-questionnaires/new-questionnaires.module').then(m => m.NewQuestionnairesModule),
      },
      // {
      //   path: 'update-questionnaires',
      //   loadChildren: () =>
      //     import('./modules/update-questionnaires/update-questionnaires.module').then(
      //       m => m.UpdateQuestionnairesModule
      //     ),
      // },
      // {
      //   path: 'mailings',
      //   loadChildren: () => import('./modules/mailings/mailings.module').then(m => m.MailingsModule),
      // },
      // {
      //   path: 'repo',
      //   loadChildren: () => import('./modules/repo/repo.module').then(m => m.RepoModule),
      // },
      //
      // {
      //   path: 'events',
      //   loadChildren: () => import('./modules/events/events.module').then(m => m.EventsModule),
      // },
      // {
      //   path: 'event-types',
      //   loadChildren: () => import('./modules/event-types/event-types.module').then(m => m.EventTypesModule),
      // },
      // {
      //   path: 'ipo',
      //   loadChildren: () => import('./modules/ipo/ipo.module').then(m => m.IpoModule),
      // },
      // {
      //   path: 'bonds-ipo',
      //   loadChildren: () => import('./modules/bonds-ipo/bonds-ipo.module').then(m => m.BondsIpoModule),
      // },
      //
      // {
      //   path: 'showcases',
      //   loadChildren: () => import('./modules/showcase/showcases/showcases.module').then(m => m.ShowcasesModule),
      // },
      // {
      //   path: 'invest-ideas',
      //   loadChildren: () => import('./modules/invest-ideas/invest-ideas.module').then(m => m.InvestIdeasModule),
      // },
      // {
      //   path: 'recommendations',
      //   loadChildren: () =>
      //     import('./modules/invest-consulting/recommendations.module').then(m => m.RecommendationsModule),
      // },
      // {
      //   path: 'securities-collections',
      //   loadChildren: () =>
      //     import('./modules/securities-collections/securities-collections.module').then(
      //       m => m.SecuritiesCollectionsModule
      //     ),
      // },
      // {
      //   path: 'banners',
      //   loadChildren: () => import('./modules/banners/banners.module').then(m => m.BannersModule),
      // },
      // {
      //   path: 'images',
      //   loadChildren: () => import('./modules/images/images.module').then(m => m.ImagesModule),
      // },
      // {
      //   path: 'publications',
      //   loadChildren: () => import('./modules/publications/publications.module').then(m => m.PublicationsModule),
      // },
      // {
      //   path: 'wl-articles',
      //   loadChildren: () => import('./modules/wl-articles/wl-articles.module').then(m => m.WlArticlesModule),
      // },
      // {
      //   path: 'applications',
      //   loadChildren: () => import('./modules/applications/applications.module').then(m => m.ApplicationsModule),
      // },
      // {
      //   path: 'report-i-c',
      //   loadChildren: () =>
      //     import('./modules/reports/i-c-public-documents/i-c-report.module').then(m => m.ICReportModule),
      // },
      // {
      //   path: 'report-risks',
      //   loadChildren: () => import('./modules/reports/risk-money-usage/risks.module').then(m => m.RisksModule),
      // },
      // {
      //   path: 'report-deposit',
      //   loadChildren: () => import('./modules/reports/deposit/deposit-report.module').then(m => m.DepositReportModule),
      // },
      // {
      //   path: 'registration-journal',
      //   loadChildren: () =>
      //     import('./modules/reports/registration-journal/registration-journal.module').then(
      //       m => m.RegistrationJournalModule
      //     ),
      // },
      // {
      //   path: 'clients',
      //   loadChildren: () => import('./modules/clients/clients.module').then(m => m.ClientsModule),
      // },
      //
      // {
      //   path: 'help',
      //   loadChildren: () => import('./modules/help/help.module').then(m => m.HelpModule),
      // },
      // {
      //   path: 'discounts',
      //   loadChildren: () => import('./modules/discounts/discounts.module').then(m => m.DiscountsModule),
      // },
      // {
      //   path: 'offers',
      //   loadChildren: () => import('./modules/offers/offers.module').then(m => m.OffersModule),
      // },
      // {
      //   path: 'transitions',
      //   component: TransitionsComponent,
      // },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
